import React from 'react';
import {Modal, View} from 'react-native';

import Text from '../Text';
import RippleAnimation from '../RippleAnimation';

import {useTheme, useThemedStyles} from '../../../theme';
import makeStyles from './styles';
import {tID} from '../../../utils/TestIdHelper';

//  Popup
//  pass in visibility flag, title and description. any buttons should be passed as children
//  Example:
// <Popup
//   visible={modalVisible}
//   title = 'Request Access'
//   description='A nice description'
// >
//   <Button
//     style={styles.button}
//     onPress={() => setModalVisible(false)}
//     title={"Close"}
//   />
//   <Button
//     style={[styles.button]}
//     onPress={() => navigation.navigate('OnBoardingExperience')}
//     title={"Request Now"}
//     buttonType={2}
//     titleColor={colors.textOnAccent}
//   />
// </Popup>

export default function Popup({
  title,
  description,
  visible,
  onRequestClose,
  textAlign,
  testID = '',
  showRipple,
  rippleIcon,
  rippleColor,
  modalStyle = {},
  containerStyle = {},
  modalViewStyle = {},
  ...props
}) {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      testID={testID}
      onRequestClose={onRequestClose}
      style={modalStyle}
    >
      <View
        testID={tID('Popup-View-Container')}
        style={[styles.centeredView, containerStyle]}
      >
        <View style={[styles.modalView, modalViewStyle]}>
          <Text
            testID={tID('Popup-Text-Title')}
            variation="Headline4Bold"
            color={colors.textPrimary}
            style={[styles.title, {textAlign}]}
          >
            {title}
          </Text>
          <Text
            testID={tID('Popup-Text-Description')}
            variation="Body1Regular"
            color={colors.textMuted}
            lineHeight={24}
            style={[styles.description, {textAlign}]}
          >
            {description}
          </Text>
          {showRipple && (
            <View style={styles.rippleContainer}>
              <RippleAnimation
                icon={rippleIcon}
                size={150}
                iconSize={28}
                color={rippleColor}
              />
            </View>
          )}
          <View
            testID={tID('Popup-View-Children')}
            style={styles.buttonsContainer}
          >
            {props.children}
          </View>
        </View>
      </View>
    </Modal>
  );
}
